import JSZip from 'jszip';

export async function downloadFolder(svgContent, externalResources, baseName) {
  const zip = new JSZip();
  const mainFolder = zip.folder(baseName);
  mainFolder.file(`${baseName}.svg`, svgContent);
  const imagesFolder = mainFolder.folder('images');

  for (const resource of externalResources) {
    imagesFolder.file(resource.name, resource.blob);
  }

  try {
    const zipContent = await zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: {
        level: 6,
      },
    });

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(zipContent);
    downloadLink.download = `${baseName}.zip`;

    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadLink.href);
  } catch (error) {
    console.error('Error generating zip file', error);
    throw error;
  }
}
